import { create } from 'zustand';
import { Lesions } from 'types';
import { activateVesselReconstruction,
  deactivateVesselReconstruction } from 'utils/cornerstone/vesselReconstruction';
import useActiveVolumes from 'stores/activeVolumes';
import { doesActiveVolumesHaveVesselData } from 'utils/utilities';

interface VesselReconstructionState {
  isVesselReconstructionActive: boolean;
  // eslint-disable-next-line
  toggleVesselReconstruction: (activeLesion?: Lesions) => Promise<void>;
}

const useIsVesselReconstructionActive = create<VesselReconstructionState>((set, get) => ({
  isVesselReconstructionActive: false,

  toggleVesselReconstruction: async (activeLesion) => {
    const { activeVolumesData } = useActiveVolumes.getState();
    if (!doesActiveVolumesHaveVesselData(activeVolumesData)) return;

    const { isVesselReconstructionActive } = get();

    // Flip the active state
    set({ isVesselReconstructionActive: !isVesselReconstructionActive });

    // Depending on state, activate or deactivate
    if (!isVesselReconstructionActive) {
      activateVesselReconstruction(activeVolumesData!);
    } else {
      await deactivateVesselReconstruction(activeLesion, activeVolumesData!);
    }
  },
}));

// Auto-disable vessel reconstruction if volumes lose vessel data
useActiveVolumes.subscribe((state) => {
  const { isVesselReconstructionActive } = useIsVesselReconstructionActive.getState();
  if (!doesActiveVolumesHaveVesselData(state.activeVolumesData) && isVesselReconstructionActive) {
    useIsVesselReconstructionActive.setState({ isVesselReconstructionActive: false });
  }
});
export default useIsVesselReconstructionActive;
